/**
 * @component feed-filters-modal
 * @css feed-filters-modal.css
 * @primitives btn btn-secondary, feed-filters
 */
class FeedFiltersModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this._keydownHandler = this._keydownHandler.bind(this);
  }

  connectedCallback() {
    this.render();
    this.attachEventListeners();
  }

  render() {
    this.innerHTML = `
      <div class="feed-filters-modal ${this.isOpen ? 'open' : ''}" id="feedFiltersModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>🔍 Feed filters</h3>
            <button type="button" class="close-btn" id="closeBtn" aria-label="Close">×</button>
          </div>

          <div class="modal-body">
            <p class="modal-description">
              Hide categories from your home feed and new-post emails.
            </p>
            ${this.isOpen ? '<feed-filters></feed-filters>' : ''}
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="doneBtn">Done</button>
          </div>
        </div>
      </div>
    `;
  }

  attachEventListeners() {
    const closeBtn = this.querySelector('#closeBtn');
    const doneBtn = this.querySelector('#doneBtn');
    const backdrop = this.querySelector('#modalBackdrop');

    const closeModal = () => {
      this.close();
    };

    closeBtn?.addEventListener('click', closeModal);
    doneBtn?.addEventListener('click', closeModal);
    backdrop?.addEventListener('click', closeModal);
  }

  _keydownHandler(event) {
    if (this.isOpen && event.key === 'Escape') {
      this.close();
    }
  }

  open() {
    this.isOpen = true;
    document.removeEventListener('keydown', this._keydownHandler);
    this.render();
    this.attachEventListeners();
    document.addEventListener('keydown', this._keydownHandler);

    setTimeout(() => {
      this.querySelector('#doneBtn')?.focus();
    }, 100);
  }

  close() {
    this.isOpen = false;
    document.removeEventListener('keydown', this._keydownHandler);
    this.render();
    this.attachEventListeners();
  }
}

customElements.define('feed-filters-modal', FeedFiltersModal);
